<script>
import { mapState } from 'vuex';
import Promo from '@/components/Launchpad/Promo';
import Header from '@/components/Launchpad/Header';
import Features from '@/components/Launchpad/Features';
import SaleTable from '@/components/Launchpad/SaleTable';
import UpcomingProducts from '@/components/Launchpad/UpcomingProducts';

export default {
  name: 'LaunchPad',
  components: {
    Promo,
    Header,
    Features,
    SaleTable,
    UpcomingProducts,
  },
  computed: {
    ...mapState({
      chainId: (state) => state.User.chainId,
    }),
    isAllowedChain() {
      return [1, 4, 56, 97, 43113, 43114, null].includes(this.chainId);
    },
  },
};
</script>

<template>
  <div class="main-wrap launchpad mt-5">
    <div v-if="!isAllowedChain" class="container">
      <v-row justify="center">
        <h1>{{ $t('upcoming.ethereum-only') }}</h1>
      </v-row>
    </div>
    <div v-else>
      <Promo />
      <div class="container">
        <div class="mt-md-10">
          <Header />
          <Features />
          <SaleTable />
          <UpcomingProducts />
        </div>
      </div>
    </div>
    <div class="text-right launchpad__link">
      <router-link :to="{ name: 'agreement' }">User Agreement</router-link>
    </div>
  </div>
</template>

<style lang="scss">
.launchpad {
  &__title {
    font-weight: 900;
    font-size: 4.4rem;
  }

  &__subline {
    font-weight: 700;
    font-size: 3.4rem;
  }

  &__link {
    font-size: 1.8rem;
    margin-top: 5rem;
  }
}
</style>
